__turbopack_context__.v({
  "className": "poppins_62ead112-module__Esvh6a__className",
  "variable": "poppins_62ead112-module__Esvh6a__variable",
});
